<template>
	<div class="login-modal-sso">
		<b-modal :id="modalId" centered hide-header hide-footer @visible="handleCloseModal">
			<h2 class="login-modal__title font-size-24 font-sanpro-semibold primary-color-txt text-center">Đăng nhập</h2>
			<p class="login-modal__desc secondary-color-txt font-sanpro-light">
                Tính năng hoặc học liệu này yêu cầu đăng nhập.
            </p>
			<div class="login-moal__form">
				<div class="login-modal__form__action">
						<button 
							type="submit" 
							class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold full-width display-flex-center justify-content-center line-height-1" 
                    
							@click="handleLogin"
						>
							Đăng nhập
						</button>                  
					</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { ID_MODAL_LOGIN_SSO } from '@/store/auth/constants';
    import { APP_CONFIG } from "@/utils/constants";
	export default {
		name: 'LoginPopup',
		data () {
			return {
				modalId: ID_MODAL_LOGIN_SSO,
                configKeyclock: {}
			}
		},
		components: {},
		computed: {
			...mapState('auth', ['isOpenLoginFormSSO']),
		},
		watch: {
			isOpenLoginFormSSO(newVal) {
				if(newVal) {
					this.$bvModal.show(ID_MODAL_LOGIN_SSO);
				} else {
					this.$bvModal.hide(ID_MODAL_LOGIN_SSO);
				}
			}
		},
		mounted() {
			this.$root.$on('bv::modal::hide', () => {
		      this.setToggleLoginSSOForm(false);
		    })
		},
		methods: {
            ...mapActions("auth", [ "setToggleLoginSSOForm"]),
			openModal() {
				this.$bvModal.show(ID_MODAL_LOGIN);
			},

			async handleLogin() {
                const request = await fetch(APP_CONFIG.dataUrl+"IsLoginkeyCloak");
                const response = await request.json();
                this.configKeyclock = response
				const pageUrl = window.location.href.replace('&','th98th');
                window.location.href= this.configKeyclock.urlServerKeyCloak+"/realms/"+this.configKeyclock.realm+"/protocol/openid-connect/auth?response_type=code&client_id="+this.configKeyclock.audience+"&redirect_uri="+window.location.origin+this.configKeyclock.redirect +'?urlReturn='+ pageUrl
			},

			handleCloseModal() {
				this.setToggleLoginSSOForm(false);
			},

			handleLogout() {
				this.$bvModal.hide(ID_MODAL_LOGIN);
			},
		}
	}
</script>

<style lang="scss">
	.icon-switch{
		position: absolute;
		top: 7px;
		right: 10px;
		i{
		color: #40505E;
		font-size: 14px;
		opacity: .5;
		}
	}
	#modal_login_sso {
		.modal-content {
			border: 0;
			max-width: 365px;
    		margin: auto;
    		border-radius: 20px;

    		@media screen and ( max-width: 575px ) {
    			max-width: 90%;
    		}
		}

		.modal-body {
			background: #fff;
			padding: 15px;
			border-radius: 15px;
		}

		.forgot-pass-btn {
			padding: 0;
		}

		.error {
			margin-top: 7px;
		}

		.login-modal-sso {

			&__title, &__readmore, &__forgot {
				margin-bottom: 15px;
			}

			&__desc {
				margin-bottom: 10px;
			}

			&__form {
				&__item {
					margin-bottom: 15px;
				}

				&__action {
					margin: 10px 0 18px;
				}
			}
		}
	}
</style>